import React, { useEffect, useState, useRef } from 'react';
import { useStyle } from '../lib/util/classify';
import defaultClasses from './configuratorWizard.module.css';
import classNames from '../lib/util/classNames';

const ConfiguratorWizard = props => {
    const { steps, selectedIndex, onSelect } = props;
    const classes = useStyle(defaultClasses, props.classes);
    const wizard = useRef();

    // we use this state variable to skip scroll on page load
    const [firstRun, setFirstRun] = useState(true);

    useEffect(() => {
        if (firstRun) {
            setFirstRun(false);
            return;
        }
        const target = wizard.current.querySelector(
            `[index="${selectedIndex}"]`
        );

        const position = target.getBoundingClientRect();

        window.scrollTo(position.left, position.top + window.scrollY - 200);
        // Revise this code, moving the whole window
        // const a = setTimeout(() => {
        //     // debugger;
        //     // target.scrollIntoView({
        //     //     behavior: 'smooth',
        //     //     block: 'nearest',
        //     //     inline: 'start'
        //     // });
        // }, 600);

        // return () => clearTimeout(a);
    }, [selectedIndex]);

    const block = steps.map((item, index) => {
        const { label, ...rest } = item;

        return (
            <li
                key={index}
                className={classNames(
                    classes.item,
                    index == selectedIndex && classes.active,
                    selectedIndex > index && classes.done
                )}
                onClick={() => onSelect(index)}
                {...rest}
            >
                <div>{label}</div>
            </li>
        );
    });

    return (
        <ul ref={wizard} className={classes.root}>
            {block}
        </ul>
    );
};

ConfiguratorWizard.defaultProps = {
    selectedIndex: 0
};

export default ConfiguratorWizard;
